import React, { createRef, lazy }  from 'react';
import { Scrollbars } from "react-custom-scrollbars-2";

import WidgetPreview from './gen2_widgets/base/WidgetPreview.jsx';
import CollapsibleSection from '../common/CollapsibleSection.jsx';
import { fetchJson } from '../../helpers/fetch.js';

import {
  dashboard_search_existing_widgets_path
} from '~/routes';

export default class WidgetLibrary extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      search: '',
      existingSearch: '',
      existingWidgets: null,
      existingSearchPage: 1,
      existingTotalCount: null,
      existingSearching: false
    }
    this.searchingExistingWidgetsRef = createRef();

    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.createWidgetComponent = this.createWidgetComponent.bind(this);
    this.searchExistingWidgets = this.searchExistingWidgets.bind(this);
    this.handleExistingScroll = this.handleExistingScroll.bind(this);
    this.debouncedSearch = _.debounce(value => {
      this.searchExistingWidgets(value);
    }, 1000).bind(this);
  }

  componentDidMount() {
    this.debouncedSearch(this.state.existingSearch);
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.existingSearch !== this.state.existingSearch) {
      this.debouncedSearch(this.state.existingSearch);
    }
  }

  handleExistingScroll(values) {
    const { scrollTop, scrollHeight, clientHeight } = values;
    const atBottom = scrollHeight - clientHeight - scrollTop <= 2;

    if (atBottom && Array.isArray(this.state.existingWidgets) && this.state.existingTotalCount > this.state.existingWidgets.length) {
      this.debouncedSearch();
    }
  }

  /**
   * Set the wrapper ref
   */
  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  /**
   * Alert if clicked on outside of element
   */
  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.props.callbacks.toggleLibrary();
    }
  }

  /**
   * Render widget preview. Gen2 widgets use a WidgetPreview component that
   * doesn't contain widget data.
   */
  createWidgetComponent(widget, i){
      return <WidgetPreview widget={widget} key={`widget-preview-${i}`} />
  }

  async searchExistingWidgets(query = null) {
    if (this.searchingExistingWidgetsRef.current) return;
    this.searchingExistingWidgetsRef.current = true;
    this.setState({existingSearching: true});

    let page = query != null ? 1 : this.state.existingSearchPage + 1;
    let existingWidgets = query != null ? [] : (this.state.existingWidgets);
    let actualQuery = query != null ? query : this.state.existingSearch;

    const foundWidgets = await fetchJson(dashboard_search_existing_widgets_path({query: actualQuery, page: page, per_page: 10, dashboard_id: this.props.dashboardId}));
    this.setState({
      existingSearching: false,
      existingSearchPage: page,
      existingWidgets: [...existingWidgets, ...foundWidgets],
      existingTotalCount: foundWidgets?.[0]?.total_count || 0
    })
    this.searchingExistingWidgetsRef.current = false;
  }

  render() {
    const height = jQuery(window).height() - jQuery('#content.container-fluid').position().top - jQuery('.dashboard-toolbar').outerHeight();
    const bottom = jQuery('.dashboard-toolbar').outerHeight();
    const { search, existingSearch } = this.state;
    const { availableWidgets } = this.props;

    // Add report and old and only filter by search to include deprecated / report variable widgets
    const groupKeys = ['layout', 'charts', 'apps_feeds', 'controls'];//, 'report', 'old'];
    const activeAvailableWidgets = availableWidgets.filter(w => !w.warning && groupKeys.includes(w.group) && w.settings.title.toUpperCase().includes(search.toUpperCase()));
    const groups = Object.groupBy(activeAvailableWidgets, w => w.group);

    return <div
      ref={this.setWrapperRef}
      className={"widget-library noselect"}
      style={(this.props.dragOngoing ?
        { opacity: '0', pointerEvents: 'none', height: height, bottom: bottom } :
        { height: height, bottom: bottom })}>
      <h4>{I18n.t('new_widgets')}</h4>
      <p style={{paddingTop: 0, marginBottom: 5}} className='description'>{I18n.t('widget_library_dnd_info')}</p>
      <input 
        type='search' 
        className='form-control input-sm' 
        onChange={(e) => {this.setState({search: e.target.value})}} 
        value={search}
        autoComplete={false}
        placeholder={I18n.t('search_widgets')} />
        {groupKeys.map(groupKey => (
          <CollapsibleSection collapsed={!search || !groups[groupKey]?.length} key={groupKey} title={I18n.t(`widget_group_title_${groupKey}`)} description={I18n.t(`widget_group_description_${groupKey}`)}>
            {!groups[groupKey]
              ? <p style={{marginLeft: '1.5rem'}}>{I18n.t('no_widgets_found')}</p>
              : groups[groupKey].map((widget, i) => this.createWidgetComponent(widget, i))}
          </CollapsibleSection>
        ))}
      {/* Hide for now, not really usable this way. Would have to be some proper library with preview etc.
      <h4>{I18n.t('existing_widgets')}</h4>
      <p style={{paddingTop: 0, marginBottom: 5}} className='description'>{I18n.t('existing_widgets_description')}</p>
      <input
        type='search'
        className='form-control input-sm' 
        onChange={(e) => this.setState({existingSearch: e.target.value})}
        value={existingSearch}
        placeholder={I18n.t('search_existing_widgets')}
        style={{marginBottom: 10}}
      />
      <Scrollbars style={{height: 690}} onUpdate={this.handleExistingScroll}>
        {(this.state.existingWidgets || []).map((widget, i) => this.createWidgetComponent(widget, i))}
        {this.state.existingSearching && <p style={{marginLeft: '1rem'}}>{I18n.t('loading')}</p>}
        {!this.state.existingSearching && this.state.existingWidgets && this.state.existingWidgets.length === 0 &&
          <p style={{marginLeft: '1rem'}}>{I18n.t('no_existing_widgets_found')}</p>
        }
      </Scrollbars> */}
    </div>
  }
};